import { connect } from 'react-redux';
import { createToolbarEvent } from '../../../analytics/AnalyticsEvents';
import { sendAnalytics } from '../../../analytics/functions';
import { translate } from '../../../base/i18n/functions';
import { IconMeter } from '../../../base/icons/svg';
import AbstractButton from '../../../base/toolbox/components/AbstractButton';
import { toggleNkfTxMeter } from '../../actions';
import { isNkfTxMeterOpen } from '../../functions';
/**
 * 送信メーターを開閉するツールバー項目。
 *
 * 送信経路の各点(相手の音 / マイク入力 / AEC出力 / ゲイン後 / 送信)の音量と、
 * それぞれで一番強い成分の周波数を出す。音程のある雑音がどこで生まれたかは、
 * 鳴っているかどうかではなく周波数が途中で変わるかどうかで決まるので、
 * 一点だけ見ても分からない。
 *
 * 以前は ?nkfMeter=1 でしか開けなかったが、Jitsi が入室時に URL を書き換える
 * ためパラメータが消え、入室後は開けなかった。
 */
class NkfTxMeterButton extends AbstractButton {
    accessibilityLabel = 'toolbar.accessibilityNkfTxMeter';
    icon = IconMeter;
    label = 'toolbar.nkfTxMeter';
    toggledLabel = 'toolbar.nkfTxMeterOff';
    tooltip = 'toolbar.nkfTxMeter';
    /**
     * メーターを切り替える。
     *
     * @override
     * @protected
     * @returns {void}
     */
    _handleClick() {
        const { _open, dispatch } = this.props;
        sendAnalytics(createToolbarEvent('nkf.txmeter', { enable: !_open }));
        dispatch(toggleNkfTxMeter());
    }
    /**
     * 表示中はトグル(ON)。
     *
     * @override
     * @protected
     * @returns {boolean}
     */
    _isToggled() {
        return this.props._open;
    }
}
/**
 * Maps part of the redux state to the component's props.
 *
 * @param {IReduxState} state - The redux state.
 * @returns {Object}
 */
function mapStateToProps(state) {
    return {
        _open: isNkfTxMeterOpen(state)
    };
}
export default translate(connect(mapStateToProps)(NkfTxMeterButton));
